import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import React from "react";
import NationalUniversityData from "../../../../components/admin/nationalUniversity/NationalUniversityData";

const NationalUniversityManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.nomenclatures.national.university")}>
      <NationalUniversityData></NationalUniversityData>
    </PageWrapper>
  );
};

export default NationalUniversityManagement;
